import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function LogisticsPage() {
  return <IndustryDetailPage slug="logistics" />;
}